import * as React from 'react'

function IconHexagon({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={110}
      viewBox="0 0 104 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#filter3_hexagon)" fill={color}>
            <path d="M78 0H26L0 54.528l26 54.531h52l26-54.531L78 0z" />
            <path
              d="M30.688 101.189L8.432 54.528 30.688 7.87H72.75l22.256 46.658-22.256 46.661H30.69z"
              stroke="#fff"
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="filter3_hexagon"
              x={0}
              y={0}
              width={104}
              height={109.059}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M78 0H26L0 54.528l26 54.531h52l26-54.531L78 0z"
            fill={color}
          />
          <path
            d="M30.689 101.189L8.433 54.528 30.689 7.87h42.06l22.257 46.658-22.257 46.661H30.69z"
            fill="#fff"
            stroke={color}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconHexagon
